import { useEffect } from "react";
import { useSelector } from "react-redux";
import ContainerLayout from "../../layouts/two-columns/container-layout";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import PreferencesPageComponent from "./components/preferences-page.component";

export default () => {
  const path = "%2Fpreferences";
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, []);

  return (
    <>
      <ContainerLayout breadcrumbPath={""} isBreadcrumbPath={false} showAds={true} showSocialMedia={false}>
        <PreferencesPageComponent />
      </ContainerLayout>
    </>
  );
};
